// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.error {\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 80%;\n  color: var(--portal-danger);\n}\n", ""]);
// Exports
module.exports = exports;
